import React, { useEffect } from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { useSnackbarContext } from '@skillzet/components';

import { TIME_IN_MILLISECONDS } from '@app/common/constants/dateAndTimeConstants';
import {
  addGDPRCookies,
  checkCookieExists,
  checkEUcountries,
  removeGDPRCookies,
  setGDPRCookie,
} from '@app/common/helpers/cookieHelpers';

interface ICookieBannerProps {
  id: string;
  country?: string;
}

function CookieBanner(props: ICookieBannerProps): JSX.Element {
  const { show, hide } = useSnackbarContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCookieBannerClose = (event?: React.SyntheticEvent): void => {
    removeGDPRCookies();
  };

  const handleCookieBannerCTA = (): void => {
    setGDPRCookie(true);
    // only add non-essential cookies when user is logged in and has a non EU or UK country
    if (!!props.country && !checkEUcountries(props.country ?? '')) {
      addGDPRCookies();
    }
    hide();
  };

  const renderHelper = (): JSX.Element => {
    return (
      <div>
        We use cookies to optimize your experience on our site. See&nbsp;
        <a href="https://www.skillz.com/privacy-policy/">privacy policy</a>
      </div>
    );
  };

  useEffect(() => {
    let cookieArray: string[] = document.cookie.split(';');
    let hasCookie: boolean = checkCookieExists();
    cookieArray.forEach((name: string) => {
      if (name.includes('gdpr-cookie=false') || hasCookie) {
        show(renderHelper(), 'info', {
          ctaContent: 'OK',
          duration: TIME_IN_MILLISECONDS.DAY,
          ctaOnClick: () => handleCookieBannerCTA(),
          otherOnCloseAction: handleCookieBannerClose,
          icon: <InfoIcon />,
        });
      }
    });
  }, []);

  return <></>;
}

export default CookieBanner;
